import {
  Box,
  Typography,
  type BoxProps,
  type TypographyProps,
} from "@mui/material";
import { ReactNode } from "react";

interface FormSectionProps {
  title: string;
  children: ReactNode;
  columns?: number;
  direction?: BoxProps["flexDirection"];
  wrap?: boolean;
  containerProps?: BoxProps;
  fieldContainerProps?: BoxProps;
  titleProps?: TypographyProps;
}

const FormSection = ({
  title,
  direction = "row",
  wrap = true,
  columns = 1,
  children,
  containerProps,
  fieldContainerProps,
  titleProps,
}: FormSectionProps) => {
  return (
    <Box
      marginY={3}
      {...containerProps}
      sx={{
        // Ensures we aren't doubling margins on the first element
        "&:first-of-type": {
          marginTop: 0,
        },
        ...containerProps?.sx,
      }}
    >
      <Typography textTransform="uppercase" mb={0.5} {...titleProps}>
        {title}
      </Typography>

      <Box
        display="flex"
        gap={2}
        padding={2}
        pt={2.5}
        flexDirection={direction}
        flexWrap={wrap ? "wrap" : "nowrap"}
        {...fieldContainerProps}
        sx={{
          border: "solid 1px #dee2e6",
          borderRadius: "4px",
          "& > *": {
            // This lets us pass a number of columns we want into the parent
            // and calculate the flex basis from that
            // NOTE: if you want to override this property (for instance if not all cols are equal)
            // you will need to use the following syntax
            // sx={{ "&": { flex: "2 2 50%" } }}
            // Take note of the "&" in the selector. If you don't have that there this rule will take precedence
            flex: `1 1 calc(${100 / columns}% - 2em)`,
          },
          ...fieldContainerProps?.sx,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
export default FormSection;
